module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thermometer-08fc871be54f08b6c0e3c0c349bbb677.svg";